<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="card-title" id="basic-layout-form">{{ 'company.title' | translate }}</h4>
      <p class="mb-0">{{ 'companyBank.text' | translate: currentObject }}</p>
    </div>
    <div class="card-body">
      <div [class]="hasDesktopView ? 'px-3' : 'px-2'">
        <form class="form" #companyBankForm="ngForm" (ngSubmit)="onSubmit(companyBankForm)">
          <div class="form-body">
            <h4 class="form-section">
              <i class="ft-cpu"></i> {{ 'company.detailsHeader' | translate }}
            </h4>

            <!-- CompanyBankId -->
            <div class="form-group">
              <label for="CompanyBankId">{{ 'companyBank.companyBankIdFieldLabel' | translate }}</label>
              <input class="form-control" name="CompanyBankId" #CompanyBankId="ngModel"
                     [(ngModel)]="currentObject.CompanyBankId"
                     placeholder="{{'companyBank.companyBankIdFieldPlaceHolder' | translate}}"
                     readonly="readonly">
            </div>

            <!-- Bank Selection -->
            <ng-container *ngIf="!isEditMode; else ShowReadonly">
              <app-bank-selection-list [(selectedObjectId)]="currentObject.BankId"
                                       [labelText]="'companyBank.selectBankLabelText' | translate"
                                       [(companyId)]="companyId"
                                       [selectObjectText]="'companyBank.selectBankPlaceHolder' | translate"
                                       (selectedObjectChangedEvent)="handleBankChanged($event)"></app-bank-selection-list>

              <div class="form-group">
                <input type="hidden" class="form-control" name="BankId" id="BankId" #BankId="ngModel"
                       [(ngModel)]="currentObject.BankId" required>
              </div>
            </ng-container>
            <ng-template #ShowReadonly>
              <div class="form-group">
                <label for="BankName">{{ 'companyBank.companyBankNameFieldLabel' | translate }}</label>
                <input type="text" class="form-control" name="BankName" id="BankName" #BankName="ngModel"
                       [(ngModel)]="currentObject.BankName" required readonly>
              </div>
            </ng-template>

            <h4 class="form-section">
              <i class="ft-cpu"></i> {{ 'companyBank.scheduleHeader' | translate }}
            </h4>

            <div class="form-group">
              <label for="SchedulerCron">{{ 'companyBank.selectScheduleCronExpressionLabelText' | translate }}</label>
              <input type="text"
                     class="form-control"
                     name="SchedulerCron"
                     id="SchedulerCron"
                     #SchedulerCron="ngModel"
                     [(ngModel)]="currentObject.CronExpression"
                     placeholder="0 0 4,12 * * ?"
                     required>
            </div>

            <div class="form-group">
              <label for="SchedulerWindowBackward">{{ 'companyBank.selectScheduleWindowBackwardLabelText' | translate }}</label>
              <input type="text"
                     inputmode="numeric"
                     pattern="\d*"
                     class="form-control"
                     name="SchedulerWindowBackward"
                     id="SchedulerWindowBackward"
                     #SchedulerWindowBackward="ngModel"
                     [(ngModel)]="currentObject.WindowBackward"
                     placeholder="15"
                     required>

              <label for="SchedulerWindowForward">{{ 'companyBank.selectScheduleWindowForwardLabelText' | translate }}</label>
              <input type="text"
                     inputmode="numeric"
                     pattern="\d*"
                     class="form-control"
                     name="SchedulerWindowForward"
                     id="SchedulerWindowForward"
                     #SchedulerWindowForward="ngModel"
                     [(ngModel)]="currentObject.WindowForward"
                     placeholder="15"
                     required>
            </div>
          </div>
          <div class="form-actions">
            <button class="btn btn-raised btn-raised btn-warning mr-1" type="button"
                    (click)="resetForm(companyBankForm)">
              <i class="ft-x"></i> {{ 'buttons.resetText' | translate }}
            </button>
            <button [disabled]="!companyBankForm.valid" class="btn btn-raised btn-raised btn-primary mr-1"
                    type="submit">
              <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
            </button>
            <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
              <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
